import { useState } from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import HealthCheck from '../components/HealthCheck';

export default function Settings() {
  const [activeTab, setActiveTab] = useState('App Setting');

  const tabs = [
    'App Setting',
    'Ads Settings', 
    'API Setting',
    'Backend Health',
    'App Privacy Policy',
    'Terms & Condition',
    'App Update'
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'App Setting':
        return 'App Setting content goes here';
      case 'Ads Settings':
        return 'Ads Settings content goes here';
      case 'API Setting':
        return 'API Setting content goes here';
      case 'Backend Health':
        return <HealthCheck />;
      case 'App Privacy Policy':
        return 'App Privacy Policy content goes here';
      case 'Terms & Condition':
        return 'Terms & Condition content goes here';
      case 'App Update':
        return 'App Update content goes here';
      default:
        return 'App Setting content goes here';
    }
  };

  return (
    <div className="p-6 max-w-full overflow-hidden">
      {/* Back Button */}
      <div className="mb-6">
        <button className="flex items-center text-teal-600 hover:text-teal-700">
          <ArrowLeftIcon className="h-5 w-5 mr-2" />
          <span className="font-medium">Back</span>
        </button>
      </div>

      {/* Settings Header */}
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
      </div>

      {/* Tab Navigation */}
      <div className="mb-6">
        <div className="flex flex-wrap gap-x-4 gap-y-2 border-b border-gray-200 overflow-x-auto">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`pb-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                activeTab === tab
                  ? 'border-teal-600 text-gray-900'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        {renderTabContent()}
      </div>
    </div>
  );
}
